module.exports = new __parcel__URL__("filter-results-edit-skeleton.tpl.783fb7b7.svg").toString();